import React from "react";

const ReviewDetailsStep = ({ form, selectedPlan, setStep }) => {
    const workingHours = form?.workingHours || {};
    const servicesCount = form?.selectedSupplies?.length + form?.customSupplies?.length;


    const hasValue = (value) =>
        value !== null && value !== undefined && value !== "" &&
        !(Array.isArray(value) && value.length === 0);


    console.log("Supplies: ", form);

    return (
        <>

            {/* Plan */}
            {hasValue(selectedPlan) && (
                <div className="bg-white rounded-[16px] border border-[#e4e5e7] overflow-hidden">
                    <div className="flex items-center justify-between px-[20px] py-[14px] border-b border-[#f0f1f3]">
                        <p className="font-semibold text-[15px] text-[#212326]">Subscription Plan</p>
                        <button
                            onClick={() => setStep(1)}
                            className="flex items-center gap-[5px] font-semibold text-[13px] text-[#ff5323] hover:underline"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-pencil w-[12px] h-[12px]">
                                <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"></path>
                                <path d="m15 5 4 4"></path>
                            </svg>
                            Edit
                        </button>
                    </div>

                    <div className="px-[20px] py-[16px] flex items-center gap-[12px]">
                        <div class="w-[40px] h-[40px] rounded-[10px] flex items-center justify-center bg-[#fff0ec]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-sparkles w-[20px] h-[20px] text-[#ff5323]">
                                <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"></path>
                                <path d="M20 3v4"></path>
                                <path d="M22 5h-4"></path>
                                <path d="M4 17v2"></path>
                                <path d="M5 18H3"></path>
                            </svg>
                        </div>
                        <div>
                            <p className="font-semibold text-[15px] text-[#212326]">
                                {selectedPlan?.title}
                            </p>
                            <p className="font-medium text-[13px] text-[#717182]">
                                {selectedPlan?.price}/month
                            </p>
                        </div>
                    </div>
                </div>
            )}

            {/* Business Details */}
            {(hasValue(form?.shopName) || hasValue(form?.email)) && (
                <div className="bg-white rounded-[16px] border border-[#e4e5e7] overflow-hidden">
                    <div className="flex items-center justify-between px-[20px] py-[14px] border-b border-[#f0f1f3]">
                        <p className="font-semibold text-[15px] text-[#212326]">Business Details</p>
                        <button
                            onClick={() => setStep(2)}
                            className="flex items-center gap-[5px] font-semibold text-[13px] text-[#ff5323] hover:underline">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-pencil w-[12px] h-[12px]">
                                <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"></path>
                                <path d="m15 5 4 4"></path>
                            </svg>
                            Edit
                        </button>
                    </div>

                    <div className="px-[20px] py-[16px] flex flex-col gap-[8px]">
                        {hasValue(form?.shopPhoto) && (
                            <div className="flex flex-col gap-[10px]">
                                <div className="w-full h-[160px] rounded-[10px] overflow-hidden mb-[4px]">
                                    <img
                                        src={form?.shopPhoto}
                                        alt={form?.shopName}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                            </div>
                        )}
                        {hasValue(form?.shopName) && (
                            <div className="flex items-center gap-[8px]">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-store w-[16px] h-[16px] text-[#9298a0]">
                                    <path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7"></path>
                                    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
                                    <path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4"></path>
                                    <path d="M2 7h20"></path>
                                    <path d="M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7"></path>
                                </svg>
                                <p className="text-[14px] font-semibold text-[#212326]">
                                    {form.shopName}
                                </p>
                            </div>
                        )}
                        {hasValue(form?.shopEmail) && (
                            <div className="flex items-center gap-[8px]">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-mail w-[16px] h-[16px] text-[#9298a0]">
                                    <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                                </svg>
                                <p className="text-[14px] font-semibold text-[#717182]">
                                    {form.shopEmail}
                                </p>
                            </div>
                        )}
                        {hasValue(form?.phone) && (
                            <div className="flex items-center gap-[8px]">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-phone w-[16px] h-[16px] text-[#9298a0]"
                                >
                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                                </svg>
                                <p className="text-[14px] font-semibold text-[#717182]">
                                    {form.phone}
                                </p>
                            </div>
                        )}
                        {hasValue(form?.description) && (
                            <p className="font-semibold text-[13px] text-[#717182] leading-[1.5] mt-[4px]">
                                "{form.description}"
                            </p>
                        )}
                    </div>
                </div>
            )}

            {/* Location */}
            {hasValue(form?.streetAddress) && (
                <div className="bg-white rounded-[16px] border border-[#e4e5e7] overflow-hidden">
                    <div className="flex items-center justify-between px-[20px] py-[14px] border-b border-[#f0f1f3]">
                        <p className="font-semibold text-[15px] text-[#212326]">Location</p>
                        <button
                            onClick={() => setStep(3)}
                            className="flex items-center gap-[5px] font-semibold text-[13px] text-[#ff5323] hover:underline"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-pencil w-[12px] h-[12px]">
                                <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"></path>
                                <path d="m15 5 4 4"></path>
                            </svg>
                            Edit
                        </button>
                    </div>

                    <div className="px-[20px] py-[16px] flex items-start gap-[8px]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-map-pin w-[16px] h-[16px] text-[#9298a0] mt-[2px] shrink-0">
                            <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                        <p className="text-[14px] text-[#212326] font-medium">
                            {form.streetAddress}, {form.city}, {form.province}, {form.postalCode}
                        </p>
                    </div>
                </div>
            )}

            {/* Services */}
            {(hasValue(form?.selectedSupplies) || hasValue(form?.customSupplies)) && (
                <div className="bg-white rounded-[16px] border border-[#e4e5e7] overflow-hidden">
                    <div className="flex items-center justify-between px-[20px] py-[14px] border-b border-[#f0f1f3]">
                        <p className="font-semibold text-[15px] text-[#212326]">Services {servicesCount ? `(${servicesCount})` : ''}</p>
                        <button
                            onClick={() => setStep(5)}
                            className="flex items-center gap-[5px] font-semibold text-[13px] text-[#ff5323] hover:underline"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-pencil w-[12px] h-[12px]">
                                <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"></path>
                                <path d="m15 5 4 4"></path>
                            </svg>
                            Edit
                        </button>
                    </div>

                    <div className="px-[20px] py-[16px] flex flex-wrap gap-[6px]">

                        {/* DEFAULT SUPPLIES */}
                        {form?.selectedSupplies?.map((item, i) => (
                            <span
                                key={`supply-${i}`}
                                className="bg-[#f4f5f6] px-[10px] py-[4px] rounded-[8px] text-[13px] font-medium text-[#212326]"
                            >
                                {item}
                            </span>
                        ))}

                        {/* CUSTOM SUPPLIES */}
                        {form?.customSupplies?.map((item, i) => (
                            <span
                                key={`custom-${i}`}
                                className="bg-[#f4f5f6] px-[10px] py-[4px] rounded-[8px] text-[13px] font-medium text-[#212326]"
                            >
                                {item}
                            </span>
                        ))}

                    </div>
                </div>
            )}

            {/* Ink Compatibility */}
            {hasValue(form?.inkTypes) && (
                <div className="bg-white rounded-[16px] border border-[#e4e5e7] overflow-hidden">
                    <div className="flex items-center justify-between px-[20px] py-[14px] border-b border-[#f0f1f3]">
                        <p className="font-semibold text-[15px] text-[#212326]">Ink Compatibility</p>
                        <button
                            onClick={() => setStep(5)}
                            className="flex items-center gap-[5px] font-semibold text-[13px] text-[#ff5323] hover:underline"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-pencil w-[12px] h-[12px]">
                                <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"></path>
                                <path d="m15 5 4 4"></path>
                            </svg>
                            Edit
                        </button>
                    </div>

                    <div className="px-[20px] py-[16px] flex items-center gap-[8px]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-droplets w-[16px] h-[16px] text-[#4a6cf7]">
                            <path d="M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z"></path>
                            <path d="M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97"></path>
                        </svg>

                        <div className="flex flex-wrap gap-[6px]">
                            {form.inkTypes?.map((item, i) => (
                                <span
                                    key={i}
                                    className="bg-[#f0f4ff] text-[#4a6cf7] px-[10px] py-[4px] rounded-[8px] text-[13px] font-semibold capitalize"
                                >
                                    {item}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {/* Operating Hours */}
            {hasValue(workingHours) && (
                <div className="bg-white rounded-[16px] border border-[#e4e5e7] overflow-hidden">
                    <div className="flex items-center justify-between px-[20px] py-[14px] border-b border-[#f0f1f3]">
                        <p className="font-semibold text-[15px] text-[#212326]">Operating Hours</p>
                        <button
                            onClick={() => setStep(6)}
                            className="flex items-center gap-[5px] font-semibold text-[13px] text-[#ff5323] hover:underline"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-pencil w-[12px] h-[12px]">
                                <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"></path>
                                <path d="m15 5 4 4"></path>
                            </svg>
                            Edit
                        </button>
                    </div>

                    <div className="px-[20px] py-[16px] flex flex-col gap-[6px]">
                        {Object.entries(workingHours).map(([day, data]) => (
                            <div key={day} className="flex justify-between text-[13px]">
                                <span className="text-[#717182] w-[90px]">{day}</span>
                                <span className="text-[#212326] font-semibold">
                                    {data?.open
                                        ? `${data.from} - ${data.to}`
                                        : "Closed"}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default ReviewDetailsStep;
